<template>
    <div class="modal-body">
        <p>You have left this browser idle for 10 minutes.</p>
        <p>{{ time }} seconds left</p>
    </div>
</template>

<script>
    //import applicationUserManager from '../applicationusermanager'
    import SecService from '../SecurityService'
    export default {
        data() {
            return {
                time: 60,
                mgr : new SecService()
            };
        },
        created() {
            let timerId = setInterval(() => {
                this.time -= 1;
                if (!this.$store.state.idleVue.isIdle) clearInterval(timerId);

                if (this.time < 1) {
                    clearInterval(timerId);
                    // Your logout function should be over here
                    this.$store.dispatch("logout").then(() => {
                        this.mgr.signOut()
                    });
                }
            }, 1000);
        },
    };
</script>